import $ from 'jquery';
import { Core } from '../../../assets/src/scripts/core.js';

export class SliderTestimonials {
  constructor($container) {
    this.$container = $container;
    this.classes = {
      slider: 'slider-testimonials-slider',
    };
  }
}
